// Nyelvesítés
import '@common/components/Text/Text'
import '@common/common'

import lazyLoad from '@common/lazyLoad/lazyLoad'

import(
  /* webpackChunkName: "init" */
  './init'
).then(() => {
  // eslint-disable-next-line sonarjs/deprecation, @typescript-eslint/no-deprecated -- Ok, kössz.
  lazyLoad()
})
